import { isPlatformGamePath } from "../../shared/routing/game-path-mode";
import type { GameApiMode } from "../../shared/services/game-api";

function currentPathname(): string {
  return typeof window === "undefined" ? "" : window.location.pathname;
}

export function isWarchestV2Path(pathname = currentPathname()): boolean {
  return isPlatformGamePath("warchest", pathname);
}

export function resolveWarchestGameApiMode(
  pathname = currentPathname(),
): GameApiMode {
  return isWarchestV2Path(pathname) ? "game-platform" : "legacy";
}
